{
  "fr": {
    "toast": {
      "action": {
        "failed": "Une erreur inattendue s'est produite.",
        "impersonate_unauthorized": "Cette action n'est pas autorisée lors de l'emprunt d'identité d'un client.",
        "succeeded": "Action réussie",
        "unprocessable": "Un problème est survenu. Veuillez actualiser la page. Si le problème persiste, veuillez nous contacter.\nERREUR : {error}"
      },
      "create": {
        "failed": "Impossible de créer {itemName}",
        "succeeded": "{itemName} crée"
      },
      "delete": {
        "failed": "Impossible de supprimer {itemName}",
        "succeeded": "{itemName} à été supprimé",
        "succeeded_default": "Suppression réussie"
      },
      "update": {
        "failed": "Impossible de mettre à jour {itemName}",
        "succeeded": "{itemName} à été mis à jour",
        "successfully_saved": "Enregistré avec succès"
      },
      "upload": {
        "failed": "Echec du téléchargement",
        "succeeded": "Téléchargement réussi"
      },
      "upload_document": {
        "extension_invalid": "Le fichier \"{document_name}\" n'a pas d'extension valide"
      },
      "upload_image": {
        "file_too_big": "Fichier trop gros: la taille maximale du fichier est de 5 MB"
      },
      "warning": {
        "multipleFiles": "Cette exportation contient plusieurs fichiers zip. Votre navigateur peut bloquer plusieurs téléchargements. Veuillez contacter le Ziggu Support si vous n'avez téléchargé qu'un seul fichier zip."
      }
    }
  }
}
